/* eslint-disable */
import React, { useState } from 'react';

import { CartTabsContainer, TabsContainer, Tab, TabTitle } from './styles';

const CartTabs: React.FC<{
  firstTabTitle: string;
  secondTabTitle: string;
  initialActiveTab?: string;
  FirstTabIcon: React.ElementType;
  SecondTabIcon: React.ElementType;
  FirstTabContent: React.ElementType;
  SecondTabContent: React.ElementType;
}> = ({
  firstTabTitle,
  secondTabTitle,
  initialActiveTab,
  FirstTabIcon,
  SecondTabIcon,
  FirstTabContent,
  SecondTabContent,
}) => {
  const [activeTab, setActiveTab] = useState(initialActiveTab ?? secondTabTitle);

  return (
    <CartTabsContainer>
      <TabsContainer>
        <Tab
          style={{ display: firstTabTitle === 'Available' ? 'none' : '' }}
          data-testid="first-tab"
          active={activeTab === firstTabTitle}
          onClick={() => setActiveTab(firstTabTitle)}
        >
          <FirstTabIcon />
          <TabTitle>{firstTabTitle}</TabTitle>
        </Tab>
        <Tab
          data-testid="second-tab"
          active={activeTab === secondTabTitle}
          onClick={() => setActiveTab(secondTabTitle)}
        >
          <SecondTabIcon />
          <TabTitle>{secondTabTitle}</TabTitle>
        </Tab>
      </TabsContainer>

      {activeTab === firstTabTitle ? <FirstTabContent /> : <SecondTabContent />}
    </CartTabsContainer>
  );
};

export default CartTabs;
